import api, { ApiResponse } from './index'

export interface GigCategory {
    _id: string
    name: string
    slug: string
    description?: string
    icon?: string
    color?: string
    subcategories: string[]
    displayOrder: number
    isActive: boolean
    gigCount?: number
    createdAt: string
    updatedAt: string
}

export const gigCategoryApi = {
    // Get all active categories (public endpoint)
    getCategories: (): Promise<ApiResponse<{ categories: GigCategory[] }>> =>
        api.get('/gig-categories'),

    // Get category by slug
    getCategoryBySlug: (slug: string): Promise<ApiResponse<{ category: GigCategory }>> =>
        api.get(`/gig-categories/slug/${slug}`),
}